<template>
  <base-section
    id="affiliates"
    class="grey lighten-4"
    space="36"
  >
    <v-container >
      <base-section-heading title="Qui nous fait confiance ?" />

      <v-slide-group

      >
        <template v-for="(confiance, i) in confiances">
          <v-slide-item
            :key="confiance.num"
            class="align-self-center"
            style="cursor: pointer"
            v-slot:default="{ active, toggle }"
          >
            <div class="text-center">
              <v-dialog
                v-model="confiance.dialog"
                width="800"
              >
                <template v-slot:activator="{ on }">
                  <base-img
                    :src="confiance.imagelogo"
                    color="grey"
                    contain
                    height="60"
                    width="200"
                    v-on="on"
                  />
                </template>

                <v-card>
                  <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                  >
                    {{confiance.nom}}
                  </v-card-title>

                  <v-card-text>
                    <v-img
                      alt="Image"

                      cover
                      :src="confiance.imagelettre"
                    />
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      text
                      @click="close(confiance)"
                    >
                      Fermer
                    </v-btn>
                  </v-card-actions>
                  <v-scale-transition>
                    <v-icon
                      v-if="active"
                      color="white"
                      size="48"
                      v-text="'mdi-close-circle-outline'"
                    ></v-icon>
                  </v-scale-transition>
                </v-card>
              </v-dialog>
            </div>

          </v-slide-item>

          <v-responsive
            v-if="i < 6"
            :key="`divider-${i}`"
            class="text-center"
            height="56"
            width="48"
          >
            <v-divider vertical/>
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

  <script>
  export default {
    name: 'SectionAffiliates',

    methods : {
      close :(confiance) =>  {
        confiance.dialog = false
      }
    },
    computed : {
      getConfianceLength() {
        return this.confiances.length
      }
    },

    data: () => {
      return {
        //on : true,
       // dialog : false,
        confiances: [
          {
            num: '1',
            nom:"Bootlegger",
            imagelogo: require('@/assets/clients/boot.png'),
            imagelettre: require('@/assets/lettres/bootlegger.jpg'),
            dialog : false,
          },
          {
            num: '2',
            nom:"Dauphins sur le lac",
            imagelogo: require('@/assets/clients/dauphinsexterieur18k.jpg'),
            imagelettre: require('@/assets/lettres/dauphinssurlelac.jpg'),
            dialog : false,
          },
          {
            num: '3',
            nom:"École secondaire Pierre Laporte",
            imagelogo: require('@/assets/clients/ecolesecondairepierre-laporte.png'),
            imagelettre: require('@/assets/lettres/ecolesecpierrelaporte.jpg'),
            dialog : false,
          },
          {
            num: '4',
            nom:"Hôtel méditerranée",
            imagelogo: require('@/assets/clients/hotel-med.png'),
            imagelettre: require('@/assets/lettres/hotel-med.jpg'),
            dialog : false,
          },
          {
            num: '5',
            nom:"Hôtel U Ricordu",
            imagelogo: require('@/assets/clients/hotelricordu.png'),
            imagelettre: require('@/assets/lettres/uricordu.jpg'),
            dialog : false,
          },
          {
            num: '6',
            imagelogo: require('@/assets/clients/isola.png'),
            imagelettre: require('@/assets/lettres/isola.jpg'),
            dialog : false,

          },
          {
            num: '7',
            nom:"Mairie de Lento",
            imagelogo: require('@/assets/clients/logo-lentu.jpg'),
            imagelettre: require('@/assets/lettres/lento.jpg'),
            dialog : false,
          },
          {
            num: '8',
            nom: "Résidence U Pirellu",
            imagelogo: require('@/assets/clients/pirellu.jpg'),
            imagelettre: require('@/assets/lettres/residence_u_pirellu.jpg'),
            dialog : false,
          },
          {
            num: '9',
            nom:"Centre fitness Polyduim",
            imagelogo: require('@/assets/clients/polyduim.png'),
            imagelettre: require('@/assets/lettres/polydium.jpg'),
            dialog : false,
          },
          {
            num: '10',
            nom:"Hotel la Signoria",
            imagelogo: require('@/assets/clients/signoria.png'),
            imagelettre: require('@/assets/lettres/hotellasignoria.jpg'),
            dialog : false,
          },
          {
            num: '11',
            nom:"Pitrera Village",
            imagelogo: require('@/assets/clients/village.png'),
            imagelettre: require('@/assets/lettres/pitrera_village.jpg'),
            dialog : false,
          },
        ],
      }
    }
  }
</script>
